<div class="text-lg font-semibold border-bottom-2 border-cyan-500 mb-2">Ihre Bankdaten</div>
Kontoinhaber: {{ businessBanking.accountOwner }}<br />
IBAN: {{ businessBanking.iban }}<br />
BIC: {{ businessBanking.bic }}<br />
Kreditinstitut: {{ businessBanking.creditInstitution }}<br />
<ng-container *ngIf="businessBanking.authorize">
    Teilnahme am Lastschriftverfahren<br />
</ng-container>
Rechnung nur per E-Mail<br />
